import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { SELECT_SHIFT_TYPE } from "../../../api-setup/api-endpoints";

export const fetchShiftType = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: "",
    };

    const response = await POSTAPI(false, SELECT_SHIFT_TYPE, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      const transformedData = rawData.map((shiftType) => ({
        id: shiftType.shift_type_mstr_key,
        text: shiftType.name,
        sortOrder: shiftType.sort_order,
      }));

      return {
        success: true,
        shiftTypeData: transformedData,
        rawData: rawData,
      };
    } else {
      console.error("Failed to fetch shift type data:", response?.message || "Invalid response structure");
      return {
        success: false,
        shiftTypeData: [],
        rawData: [],
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching shift type data:", error);
    return {
      success: false,
      shiftTypeData: [],
      rawData: [],
      error: error.message,
    };
  }
};
